<template>
<div>
    <back title="Login" route="/" @click="callback_page"></back>
    <v-content>
        <v-container fluid>
            <p class="text-center pb-5" block>Login your <b>MyPhoneShop</b> account</p>
            <div class="buttons">
                <v-flex>
                    <v-btn color="#3B5998" dark depressed block class="text-capitalize">
                        <v-icon class="justify-start">mdi-facebook-box</v-icon>
                        <span>Facebook</span>
                    </v-btn>
                </v-flex>
                <v-flex>
                    <v-btn color="#CC3333" dark depressed block class="text-capitalize">
                        <v-icon class="justify-start">mdi-google-plus-box</v-icon>
                        <span>Google</span>
                    </v-btn>
                </v-flex>
                <v-flex>
                    <v-btn color="#1DA1F3" dark depressed block class="text-capitalize">
                        <v-icon class="justify-start">mdi-twitter-box</v-icon>
                        <span>Twitter</span>
                    </v-btn>
                </v-flex>
                <v-flex>
                    <v-btn color="#e1e1e1" depressed block class="text-capitalize" to="/login-manual">
                        Manual Login
                    </v-btn>
                </v-flex>
            </div>
            <div class="pt-4">
                <v-btn flat to="/register" class="text-capitalize text-decoration" block :ripple="false">Don’t have an Account Yet? Register here</v-btn>
            </div>
        </v-container>
    </v-content>
</div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            callback : null
        };
    },
    mounted() {
        this.callback = localStorage.getItem('callback_page') ? localStorage.getItem('callback_page') : '/'
        this.$router.replace({path:'/login-manual'});
    },
    methods: {
        removeCallback(){
            localStorage.removeItem('callback_page')
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../scss/app.scss";
</style>
